export const checkEnviromentIsB2B = () => false
